import { MyFavouritesButton } from '@/components/widgets/my-favourites-button'
import { useAccountInfo } from '@/hooks/query/account';
import { useAddLeagueToMyFavourties, useMyFavourites, useRemoveLeagueFromMyFavourites } from '@/hooks/query/my-favourties'
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { convertSabaSportToNormalSport } from '@/utils/saba-sports-util';
import { MaybeMatch } from '@nf/utils-common/fpw/monadic';
import { useEffect, useState } from 'react';

interface MyFavouritesLeagueButtonProps {
    leagueId: number;
    sportType: number;
}

export const MyFavouritesLeagueButton = ({
	leagueId,
	sportType
}: MyFavouritesLeagueButtonProps) => {
	const [isSelected, setIsSelected] = useState(false);
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();
	const { data } = useMyFavourites();
	const addLeagueToMyFavourtiesMutation = useAddLeagueToMyFavourties();
	const removeLeagueFromMyFavourtiesMutation = useRemoveLeagueFromMyFavourites();
	const sport = convertSabaSportToNormalSport(sportType);

	useEffect(() => {
		setIsSelected((data?.Ldata?.findIndex(leagueData => leagueData.LeagueId === leagueId) ?? -1)> -1)
	}, [data, leagueId])
	const onToggleMyFavoriteButton = () => {
		MaybeMatch(isSelected)
			.fold(
				() => addLeagueToMyFavourtiesMutation.mutate({
					LeagueId: leagueId,
					SportType: sport
				}),
				() => removeLeagueFromMyFavourtiesMutation.mutate({
					LeagueId: leagueId,
					OnlyLeague: sport === 999
				})
			)
	}
	return user?.ActStatus === 2 && SiteConfigsData?.EnableMyFavorite && (
		<MyFavouritesButton 
			isSelected={isSelected} 
			onToggleMyFavoriteButton={onToggleMyFavoriteButton}
		/>
	) 
}